import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Badge, CoinPointsOutline, StyleProps, Text } from '@bonusly/design-system';
import { useCurrentUser } from '@bonusly/who-am-i';

export const FlashPointsChip: FC<StyleProps> = (props) => {
	const { t } = useTranslation('common');
	const { flash_points_balance } = useCurrentUser();

	if (!flash_points_balance) return null;

	return (
		<Badge
			alignItems="center"
			borderRadius="xl"
			data-testid="flash-points-chip"
			display="inline-flex"
			px={3}
			py={1}
			mr={2}
			background="linear-gradient(105deg, #E6AE14 35%, 35%, #FCC84F 45%, 45%, #E6AE14 50%, 50%, #FCC84F 70%, 70%, #E6AE14 80%) no-repeat"
			{...props}
		>
			<CoinPointsOutline color="yellow.700" />
			<Text color="yellow.700" fontWeight="semibold" pl={1}>
				{t('intl_number', { value: flash_points_balance })}
			</Text>
		</Badge>
	);
};
